import { render, staticRenderFns } from "./ProductSkuAutocompleteWithoutModal.vue?vue&type=template&id=a454c334&scoped=true"
import script from "./ProductSkuAutocompleteWithoutModal.vue?vue&type=script&lang=ts"
export * from "./ProductSkuAutocompleteWithoutModal.vue?vue&type=script&lang=ts"
import style0 from "./ProductSkuAutocompleteWithoutModal.vue?vue&type=style&index=0&id=a454c334&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a454c334",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a454c334')) {
      api.createRecord('a454c334', component.options)
    } else {
      api.reload('a454c334', component.options)
    }
    module.hot.accept("./ProductSkuAutocompleteWithoutModal.vue?vue&type=template&id=a454c334&scoped=true", function () {
      api.rerender('a454c334', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/ProductSkuAutocompleteWithoutModal.vue"
export default component.exports